let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("cOBj9"), load("jgfeV"), load("gYKCE"), load("c6MKV"), load("aZinD"), load("4Pn6Z"), load("kaFPr")]).then(() => parcelRequire('2C4l7'));